module.exports = __webpack_public_path__ + "img/teaser_smaerteview.0de8d564.jpg";